module.exports = __webpack_public_path__ + "static/img/AG@3x.9024b992.jpg";